import { connect } from 'react-redux';
import { getLocaleProps } from '../../../selectors/app';
import { CheckoutState } from '../../../state';
import { ApplePayNativeButton } from './ApplepayNativeButton';

export default connect((state: CheckoutState) => getLocaleProps(state))(
    ApplePayNativeButton,
);
